import { render, staticRenderFns } from "./editPanel.vue?vue&type=template&id=90a680ea&"
import script from "./editPanel.vue?vue&type=script&lang=ts&"
export * from "./editPanel.vue?vue&type=script&lang=ts&"
import style0 from "./editPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports